export const StorageVariables = {
    hasSineProfile: 'srg9p87', // True or false, if has SINE profile
    geolocation: 'cvbio', // User's adresses or Istance address
    userProfile: 'asi0fjaso', // store user data from Login -
    lastPanel: '456opk', // store the last panel accessed by the user ( worker or client)
    fcm: 'asfi78y', // Last Firebase Token
};
